module.exports = __webpack_public_path__ + "static/media/barcodeImage_aztec.d549830e.svg";